<template>
  <div>
    <div v-if="curView === 'list'">
      <MaterialList @create="handleCreate" @add-material="addMaterial" />
    </div>
    <div v-if="curView === 'detail'">
      <MaterialAdd @go-back="goBack" :mode="mode" />
    </div>
    <div v-if="curView === 'addMaterial'">
      <MaterialManageAdd @go-back="goBack" :mode="mode" :material-obj="materialObj" />
    </div>
  </div>
</template>

<script>
import MaterialList from './MaterialList.vue'
import MaterialAdd from './MaterialAdd.vue'
import MaterialManageAdd from '@/views/advertisement/material/MaterialManageAdd.vue'

export default {
  components: {
    MaterialList,
    MaterialAdd,
    MaterialManageAdd
  },
  data() {
    return {
      curView: 'list',
      mode: '',
      materialObj: ''
    }
  },
  methods: {
    handleCreate() {
      this.curView = 'detail'
      this.mode = 'add'
    },
    addMaterial(row) {
      this.curView = 'addMaterial'
      this.mode = 'create'
      this.materialObj = this.cloneDeep(row)
    },
    goBack() {
      this.curView = 'list'
    }
  }
}
</script>

<style>
</style>
